module.exports = __webpack_public_path__ + "static/media/feta_meli2_thumb.c82f5c0d.jpg";